import { type FC } from 'react';
import {
  Check
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCheckProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCheck: FC<UiIconCheckProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Check}
      {...props}
    />
  );
};
